import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatButton } from '@blocks-react/components/Button';

type CatButtonProps = ComponentProps<typeof CatButton> & { classname?: string };

export const PartsDiagramRetryButton: FC<PropsWithChildren<CatButtonProps>> = ({
  children,
  ...buttonProps
}) => (
  <CatButton variant="ghost" {...buttonProps}>
    {children}
  </CatButton>
);
